import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DegreeTypeContinentRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 2 &&
			indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE) &&
			indexableFilters.some((_) => _.type === ParameterType.CONTINENT)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DEGREE_CONTINENT_ROUTE,
			params: {
				degree: this.extractPath(filters.find((_) => _.type === ParameterType.DEGREE_TYPE)),
				continent: this.extractPath(filters.find((_) => _.type === ParameterType.CONTINENT)),
			},
		};
	}
}